import { Injectable } from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import { BasicFilters } from '../model/filters/basic-filters';
import { Observable } from 'rxjs';
import { HttpUtils } from '../shared/http.utils';
import { KpiFilters } from '../model/filters/kpi-filters';
import { KpisResponse } from '../model/responses/kpis-response';
import { KpiPersistRequest } from '../model/requests/kpi-persist-request';
import { DeviceMeasurementFilters } from '../model/filters/device-measurement-filters';
import { AssetMeasurementFilters } from '../model/filters/asset-measurement-filters';

@Injectable({
  providedIn: 'root'
})
export class KpisService {

  private readonly kpisUrl: string;

  constructor(private http: HttpClient) {
    this.kpisUrl = '/catalog/kpis';
  }

  public getKpi(kpiUuid: string): Observable<any> {
    const url = `${this.kpisUrl}/${kpiUuid}`;
    return this.http.get<any>(url);
  }

  public getKpis(offset?: number, limit?: number, filters?: KpiFilters): Observable<KpisResponse> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new KpiFilters();
    return this.http.post<KpisResponse>(this.kpisUrl, body, options);
  }

  public getKpisFromUuids(kpiUuids: string[]): Observable<any> {
    const url = `${this.kpisUrl}/from-uuids`;
    return this.http.post<any>(url, kpiUuids);
  }

  public createKpi(kpiCreationData: KpiPersistRequest): Observable<any> {
    const url = `${this.kpisUrl}/create`;
    return this.http.post<any>(url, kpiCreationData);
  }

  public editKpi(kpiEditionData: KpiPersistRequest): Observable<any> {
    const url = `${this.kpisUrl}/edit`;
    return this.http.post<any>(url, kpiEditionData);
  }

  public deleteKpi(kpiUuid: string): Observable<HttpResponse<any>> {
    const url = `${this.kpisUrl}/${kpiUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteKpis(kpiUuids: string[]): Observable<HttpResponse<any>> {
    const url = `${this.kpisUrl}/delete`;
    return this.http.post<any>(url, kpiUuids, {observe: 'response'});
  }

  public getDeviceMeasurementsOfKpi(kpiUuid: string, offset?: number, limit?: number, filters?: DeviceMeasurementFilters): Observable<any> {
    const url = `${this.kpisUrl}/${kpiUuid}/components/device-measurements`;
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    return this.http.post<any>(url, filters, options);
  }

  public getAssetMeasurementsOfKpi(kpiUuid: string, offset?: number, limit?: number, filters?: AssetMeasurementFilters): Observable<any> {
    const url = `${this.kpisUrl}/${kpiUuid}/components/asset-measurements`;
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    return this.http.post<any>(url, filters, options);
  }

  public getKpisOfKpi(kpiUuid: string, offset?: number, limit?: number, filters?: KpiFilters): Observable<any> {
    const url = `${this.kpisUrl}/${kpiUuid}/components/kpis`;
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    return this.http.post<any>(url, filters, options);
  }

  public createPendingKpiCalculations(kpiUuid: string, from: number, until: number): Observable<void> {
    const url = `${this.kpisUrl}/${kpiUuid}/create-pending`;
    const params = new HttpParams().append('from', from).append('until', until);
    return this.http.post<void>(url, null, { params: params });
  }

}
